import { Box, CircularProgress } from "@mui/material";
import { useLaunchDarklyFeatureFlag } from "hooks/useLaunchDarklyFeatureFlag";
import UserManagement from "./UserManagement";
import UserManagementV2 from "./UserManagementV2";

export default function UserManagementSwitch() {
  const { featureFlagEnabled, isLoading } = useLaunchDarklyFeatureFlag({
    featureFlagName: "qmV2UserManagementPage",
    context: null,
  });

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }
  if (featureFlagEnabled) {
    return <UserManagementV2 />;
  }
  return <UserManagement />;
}
